<template>
  <span>    
    <span
      class="proj-select"
    >
      <svg font-size="24px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" class="icon workspace-svg"><path d="M1012.034 385.66l0.004-130.794c-0.004-15.654-5.32-29.036-14.968-37.684-8.552-7.666-20.052-11.148-32.362-9.8-6.444 0.708-11.62 3.098-15.78 5.016-0.758 0.346-1.506 0.7-2.266 1.028l-11.362 4.992c-140.544 61.706-281.084 123.416-421.572 185.24-1.828 0.806-2.536 0.942-2.712 0.97-0.016-0.018-0.2-0.07-0.514-0.212-82.688-36.468-165.412-72.84-248.14-109.21-35.4-15.566-70.8-31.128-106.2-46.7l162.516-73.74c63.772-28.926 127.546-57.846 191.256-86.9 0.968-0.442 1.482-0.596 1.694-0.65 0.05 0.044 0.372 0.148 0.896 0.386C601.462 128.268 734.36 188.18 734.36 188.18c7.26 3.296 16.3 7.404 27.644 6.098 19.28-2.228 33.958-16.064 37.398-35.256 3.236-18.038-6.818-36.408-24.442-44.674-17.146-8.036-180.246-81.5-239.664-108.752-16.218-7.45-31.35-7.456-47.612-0.034C314.312 84.612 172.726 148.868 42.108 207.772 17.96 218.664 6.336 238.212 11.02 260.066c4.59 21.402 19.024 27.074 57.59 42.226l9.12 3.646c1.95 0.796 3.59 1.464 5.21 2.174l84.774 37.226c104.556 45.904 212.674 93.372 318.866 140.344 16.954 7.492 32.866 7.436 50.074-0.184 86.496-38.316 174.586-76.972 259.772-114.358l71.264-31.28c18.352-8.056 36.716-16.096 55.376-24.264l4.732-2.068v53.256c-0.008 123.66-0.014 251.508 0.15 377.3-98.76 45.46-199.07 91.822-296.09 136.66l-75.96 35.104c-0.856 0.394-1.72 0.784-2.576 1.176V644.234c0-22.178-18.146-40.318-40.316-40.318h-3.834c-22.174 0-40.318 18.14-40.318 40.318v272.542c-109.326-50.794-228.256-105.66-372.92-172.038a20.532 20.532 0 0 1-0.97-0.476l0.182-10.95 0.014-269.94c0.022-2.576 0.06-5.492-0.188-8.562-1.808-22.344-19.662-39.428-41.524-39.746-22.144-0.256-40.96 17.356-42.586 40.266-0.214 2.984-0.184 5.84-0.154 8.36l0.016 2.428-0.022 296.952c-0.038 23.444 10.214 39.564 31.33 49.268 156.176 71.78 313.558 144.62 446.914 206.404 7.562 3.508 15.032 5.258 22.504 5.258 7.492 0 14.992-1.76 22.6-5.288 131.052-60.724 286.63-132.74 446.9-206.432 21.04-9.672 31.256-25.488 31.224-48.348-0.16-126.086-0.15-254.29-0.14-378.27" p-id="2015" data-spm-anchor-id="a313x.7781069.0.i0" fill="#ffffff" class="selected"></path></svg>
    </span>&nbsp;
    <Dropdown
      class="project-dro"
      placement="bottom-start"
    >
      <div style="font-size:14px">
        <p class="workspace-title">{{ currentProject.name }}</p>
        <Icon type="ios-arrow-down" style="margin-left: 5px"></Icon>
      </div>
      <DropdownMenu slot="list" class="proj-list">
        <div v-for="item in projectList"
          @click="changeProj(item)"
          :key="item.id"
          :class="{'active':item.id == currentProject.id}"
          class="proj-item">
          {{ item.name}}
        </div>
      </DropdownMenu>
    </Dropdown>
  </span>
</template>

<script>
import storage from '@dss/js/helper/storage';
export default {
  props: {
    projectList: {
      type: Array,
      default: () => [],
    },
    currentId: {
      type: Number,
      default: ()=> 0,
    },
    changeWorkSpace: {
      type: Function
    }
  },
  created(){
    
  },

  computed: {
    currentProject(){
      const current = this.projectList.filter(item=>item.id===this.currentId) || {};
      return current[0] || {};
    }
  },
  
  methods: {
    changeProj(item) {
      if(item.id !== this.currentId) {
        this.changeWorkSpace && this.changeWorkSpace(item)
      }
    },
  },

    

  
  data(){
    return {
    }
  }
}
</script>

<style lang="scss" src="./index.scss"></style>